import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import TextEditorComponent from "../textEditor/TextEditor";
import {
  DEFAULT_DISPLAY_ORDER,
  DISPLAY_ORDER_MIN,
  DISPLAY_ORDER_STEP,
} from "../faq/faqOptions";

const useStyles = makeStyles(() => ({
  content: {
    display: "flex",
    flexDirection: "column",
    minWidth: "320px",
  },
  input: {
    margin: "10px 0",
  },
  answerLabel: {
    margin: "10px 0 4px",
    opacity: 0.75,
  },
  saveButton: {
    color: "#E00186",
    border: "1px solid #E00186",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#E00186",
      border: "1px solid #E00186",
    },
  },
}));

const buildFaqFormState = (baseContentData, defaultDisplayOrder) => ({
  question: baseContentData.question || "",
  answer: baseContentData.answer || "",
  displayOrder:
    baseContentData.displayOrder ?? defaultDisplayOrder ?? DEFAULT_DISPLAY_ORDER,
});

// Renders in a Dialog on top of the FAQs list - there is no separate
// create/edit page or route, matching the Metrics management pattern.
export default ({
  open,
  onClose,
  title,
  onSubmit,
  isLoading,
  baseContentData = {},
  defaultDisplayOrder,
}) => {
  const classes = useStyles();
  const [state, setState] = useState(() =>
    buildFaqFormState(baseContentData, defaultDisplayOrder)
  );

  useEffect(() => {
    if (open) {
      setState(buildFaqFormState(baseContentData, defaultDisplayOrder));
    }
  }, [
    open,
    baseContentData._id,
    baseContentData.id,
    defaultDisplayOrder,
  ]);

  const handleChange = (event) => {
    const { id, value } = event.target;
    setState({ ...state, [id]: value });
  };

  const handleAnswerChange = (value) => {
    setState((prevState) => ({ ...prevState, answer: value }));
  };

  const handleSubmit = () => {
    onSubmit(state);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title || "FAQ Form"}</DialogTitle>
      <DialogContent className={classes.content}>
        <TextField
          id="question"
          label="Question"
          variant="outlined"
          value={state.question}
          onChange={handleChange}
          className={classes.input}
          required
        />
        <Typography variant="subtitle2" className={classes.answerLabel}>
          Answer
        </Typography>
        <TextEditorComponent value={state.answer} onTextChange={handleAnswerChange} />
        <TextField
          id="displayOrder"
          label="Display Order"
          type="number"
          value={state.displayOrder}
          onChange={handleChange}
          variant="outlined"
          className={classes.input}
          inputProps={{
            min: DISPLAY_ORDER_MIN,
            step: DISPLAY_ORDER_STEP,
          }}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          onClick={handleSubmit}
          disabled={isLoading}
          className={classes.saveButton}
        >
          {isLoading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
